import { createCacheKey, ENDPOINTS, handleErrorResponse, useCreatePayload } from 'hammock';
import { useQuery } from 'react-query';

import { VariantData } from '@candu-ai/styleguide/types';

export type useDefaultVariantsConfig = {
  iteration?: number;
  disabled?: boolean;
};

export const useDefaultVariants = (options?: useDefaultVariantsConfig) => {
  const { iteration, disabled } = options || {};

  const { getAll } = useCreatePayload(ENDPOINTS.styleguideVariants);
  const payload = getAll({ query: {} });
  const cacheKey = createCacheKey(payload);

  console.log('useDefaultVariants', cacheKey);

  const query = useQuery<VariantData, Error>(
    [...cacheKey, ...(typeof iteration !== 'undefined' ? [`${iteration}`] : [])],
    async () => {
      try {
        const [res] = (await fetch(payload.endpoint).then((r) => r.json())) as VariantData[];
        return res;
      } catch (e) {
        throw handleErrorResponse(e, payload);
      }
    },
    {
      enabled: !disabled,
    },
  );

  return {
    ...query,
    cacheKey,
  };
};
